import React, { useState } from "react";
import "./UserDoktorRightSide.css";
import logo from "../../../assets/images/logo.png";

const BASE_URL = "https://api.afazi.aridata.io";

const UserDoktorRightSide = ({ setShowFirstStep }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [fullName, setFullName] = useState("");
    const [error, setError] = useState("");
    const [isLogin, setIsLogin] = useState(true);
    const [isForgotPassword, setIsForgotPassword] = useState(false);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const apiRequest = async (endpoint, options = {}) => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                ...options,
                signal: controller.signal,
                credentials: 'include'
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || "Request failed");
            }

            return response;
        } catch (err) {
            console.error("API Request Error:", err);
            throw new Error(err.message || "An error occurred. Please try again.");
        } finally {
            clearTimeout(timeout);
        }
    };

    const handleAuth = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");
        setIsLoading(true);

        try {
            if (isLogin) {
                await handleLogin();
            } else {
                await handleSignup();
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleLogin = async () => {
        const response = await apiRequest("/auth/login", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                email: email.trim(),
                password: password
            })
        });

        const data = await response.json();
        localStorage.setItem("token", data.token);
        setShowFirstStep(true);
    };

    const handleSignup = async () => {
        // const response = await apiRequest("/auth/register", {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json",
        //         "Accept": "application/json"
        //     },
        //     body: JSON.stringify({
        //         email: email.trim(),
        //         password,
        //         full_name: fullName.trim()
        //     })
        // });

        setMessage("Registration successful! You can now log in.");
        setIsLogin(true);
    };

    const handleForgotPassword = async () => {
        if (!email) {
            setError("Please enter your email address");
            return;
        }

        setIsLoading(true);
        try {
            await apiRequest(`/auth/forgot-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email: email.trim() })
            });
            setMessage("Password reset link sent to your email");
            setIsForgotPassword(false);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="user-doktor-right-section">
            <img src={logo} alt="logo" className="logo" />
            {isForgotPassword ? (
                <div className="forgot-password-container">
                    <h2>Forgot Password</h2>
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    {message && <p className="success-message">{message}</p>}
                    <div className="button-group">
                        <button 
                            type="button" 
                            className="create-account-button"
                            onClick={handleForgotPassword}
                            disabled={isLoading}
                        >
                            {isLoading ? "Sending..." : "Send"}
                        </button>
                        <button 
                            type="button" 
                            className="toggle-auth"
                            onClick={() => setIsForgotPassword(false)}
                        >
                            Back
                        </button>
                    </div>
                </div>
            ) : (
                <form className="form" onSubmit={handleAuth}>
                    {!isLogin && (
                        <div className="form-group">
                            <label>Full Name</label>
                            <input
                                type="text"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                required
                            />
                        </div>
                    )}
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            placeholder="Password (6+ characters)"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            minLength={6}
                        />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    {message && <p className="success-message">{message}</p>}
                    <button 
                        type="submit" 
                        className="create-account-button"
                        disabled={isLoading}
                    >
                        {isLoading ? "Processing..." : (isLogin ? "Login" : "Register")}
                    </button>
                    <div className="auth-options">
                        <p onClick={() => setIsLogin(!isLogin)} className="toggle-auth">
                            {isLogin ? "Don't have an account? Register" : "Already have an account? Login"}
                        </p>
                        {isLogin && (
                            <p 
                                onClick={() => setIsForgotPassword(true)}
                                className="toggle-auth forgot-password"
                            >
                                Forgot Password
                            </p>
                        )}
                    </div>
                </form>
            )}
        </section>
    );
};

export default UserDoktorRightSide;
